const YOUTUBE_API_ROOT = 'https://youtube.s-prod.pow.io/';
const DEFAULT_PLAYLIST = 'PLuq_rgCzEP_Nfzo3fFntwhGdMMiLG4GUb';

export async function getYoutubePlaylist(id = DEFAULT_PLAYLIST) {
	try {
		const url = new URL('getPlaylistData', YOUTUBE_API_ROOT);
		url.searchParams.set('playlistId', id);
		const response = await fetch(url);

		if (!response.ok) throw new Error(`Youtube playlist HTTP error ${response.status}`);
		const data = await response.json();
		return data.items;
	} catch (error) {
		// rethrow error ?
		return [];
	}
}
